import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './services/auth.service';
import { HyperDxService } from './services/hyperdx.service';
import { IntercomService } from './services/intercom.service';
import { PromptUpdateService } from './services/prompt-update.service';

/**
 * Configuração do banner global.
 *
 * Para ativar um aviso, basta alterar o objeto GLOBAL_BANNER abaixo:
 *
 *  - type: 'warning' → banner vermelho de alerta (expansível)
 *  - type: 'success' → snackbar verde discreta
 *  - type: null      → nenhum banner exibido
 *
 *  - message: texto principal (aceita HTML inline como <strong>)
 *  - details: (apenas warning) lista de instruções exibidas no corpo expandido
 *  - expiresAt: (opcional, apenas success) data/hora em que o banner expira e para de aparecer
 */
const GLOBAL_BANNER: {
  type: 'warning' | 'success' | null;
  message: string;
  details?: string[];
  expiresAt?: string;
} = {
  type: 'success',
  message: 'Os envios via <strong>WhatsApp</strong> foram normalizados. Tudo funcionando! ✅',
  expiresAt: '2026-03-28T21:40:00',  // 24h após 27/03 às 21:40

  // Exemplo de configuração de alerta (basta trocar type para 'warning'):
  // type: 'warning',
  // message: 'A <strong>META (WhatsApp)</strong> está passando por uma instabilidade para os envios de documentos.',
  // details: [
  //   'Ao fazer o fluxo de envio da documentação pelo sistema, vá na aba de <strong>assinaturas</strong> e clique na opção de <strong>reenviar</strong> (aviãozinho).',
  //   'Caso mencione algo sobre o envio de um código de validação, marquem a opção de <strong>enviar o código por SMS</strong>.',
  // ],
};

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent implements OnInit {
  title = 'westetics-front';

  bannerType: 'warning' | 'success' | null = GLOBAL_BANNER.type;
  bannerMessage = GLOBAL_BANNER.message;
  bannerDetails = GLOBAL_BANNER.details || [];
  bannerExpanded = true;

  constructor(
    private router: Router,
    private authService: AuthService,
    private hyperDxService: HyperDxService,
    private intercomService: IntercomService,
    private promptUpdateService: PromptUpdateService
  ) {
  }

  ngOnInit(): void {
    // Configura o HyperDxService no AuthService para evitar dependência circular
    this.authService.setHyperDxService(this.hyperDxService);
    this.promptUpdateService.checkForUpdates();

    // Inicializa o Intercom se o usuário já estiver logado (ex: refresh da página)
    if (this.authService.isLogged()) {
      this.intercomService.boot();
    }

    // Desativa o banner se expirou
    if (GLOBAL_BANNER.expiresAt && new Date() > new Date(GLOBAL_BANNER.expiresAt)) {
      this.bannerType = null;
    }
  }

  toggleBannerExpanded(): void {
    this.bannerExpanded = !this.bannerExpanded;
  }
}
